<!--
2023-08-17 YTW Vip体系
-->
<template>
  <div class="main-content">
    <div class="top">
      <TopBack id="TopBack" style="z-index: 1;" :handelBack="gotoHome"/>
      <div class="title">{{ $t('lang.VIP.vipBenefits') }}</div>
      <div class="alarm" v-if="getDateEnd()" @click="getAlarmMsg"><img :src="alarm" alt=""/></div>
      <div class="red-alarm-dot" v-if="getDateEnd()&&alarmRedShow"/>
    </div>
    <div class="swiperBox">
      <div class="swiper-background"
           :style="{backgroundImage:'url('+require('../../assets/images/vip/g'+levelIndex+'.svg')+')'}">
      </div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in vipConfigList" :key="index">
            <div class="img-box"
                 :style="{backgroundImage:'url('+require('../../assets/images/vip/v'+index+'.svg')+')'}">
              <div class="img-box-title">
                <span class="vip-level" :style="{color:item.color1}">VIP{{ item.level }}</span>
                <div class="current-level" :style="{color:item.color6,border:'1px solid'+item.color6}">
                  <div>{{ getVipLevelText(item.level) }}</div>
                </div>
              </div>
              <div class="middle-box">
                <div :style="{color:item.color2}" v-if="index!==0">{{
                    vipSettingInfo[index].NumberOfActivities
                  }}{{ $t('lang.VIP.beingHeld') }}
                </div>
                <div :style="{color:item.color2}" v-else>
                  {{ $t('lang.VIP.upgradeBenefits') }}
                </div>
                <div :style="{color:item.color3}">{{ calcAmountNotReached(index) }}</div>
              </div>
              <div class="bottom-line" v-if="index!==0">
                <div style="width: 54.4vw">
                  <progressLine
                    :vipConfigList="vipConfigList"
                    :level="index"
                    :total="vipSettingInfo[index].TargetValue"
                    :current="vipSettingInfo[index].ReachedValue">
                  </progressLine>
                </div>
                <div :class="item.level===10||item.level===11?'color3_shadow':'color3'" :style="{color:item.color3}">
                  {{ vipSettingInfo[index].TargetValue }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="last-boxes-container">
      <div class="enjoymentBox" :style="{backgroundImage:'url('+require('../../assets/images/vip/circle.png')+')'}">
        <div class="enjoyment-top">
          <div class="title" v-if="levelIndex!==0">
            {{ $t('lang.VIP.enjoyTheMost') }}{{
              vipSettingInfo[levelIndex].NumberOfActivities
            }}{{ $t('lang.VIP.benefits') }}
          </div>
          <div class="title" v-else>{{ $t('lang.VIP.upgradeBenefits') }}</div>
          <div class="seeAll" @click="enjoyDetail(0)">
            {{ $t('lang.VIP.seeAll') }}
            <img :src="left">
          </div>
        </div>
        <div class="enjoyment-bottom">
          <div class="bottom-row">
            <div class="row-item" v-for="(item,index) in enjoyImg" :key="index"
                 :style="index===0?'margin-right:5vw':''">
              <div class="imgHull">
                <div class="red-dot" v-if="(index ===2||index===3)&&userVipInfo.FirstLevelSixHint"/>
                <img :src="item.img" @click="enjoyDetail(index===2?9:(index===3?10:index))">
              </div>
              <div class="enjoy-text" v-if="index ===0" style="max-width: 15vw;">{{ item.text }}</div>
              <div class="enjoy-text" v-if="index ===1" style="max-width: 15vw;">{{ item.text }}
              </div>
              <div class="enjoy-text" v-if="index ===2" style="max-width: 30vw;"
                   :style="$store.state.locale==='IN'?'margin-left: 2vw;':''">{{ item.text }}
              </div>
              <div class="enjoy-text" v-if="index ===3" style="max-width: 24.5vw;"
                   :style="$store.state.locale==='IN'?'margin-left: 2vw;':''">{{ item.text }}
              </div>
              <div class="enjoy-amount" v-if="index===0">{{ vipSettingInfo[levelIndex].UpVipReward }}</div>
              <div class="enjoy-amount" v-if="index===1">{{ vipSettingInfo[levelIndex].Card }}</div>
              <div class="enjoy-amount" v-if="index===2">{{ vipSettingInfo[levelIndex].Promotion ? 'Yes' : 'No' }}</div>
              <div class="enjoy-amount" v-if="index===3">{{
                  vipSettingInfo[levelIndex].CustomerManager ? 'Yes' : 'No'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="getGiftBox">
        <div class="getGiftBox-row">
          <div class="getGiftBox-top" style="float: left">
            <img :src="star">
            <div>
              <p> {{ $t('lang.VIP.cashAvailable') }}</p>
            </div>
            <div class="black" @click="goto('VipMembershipRecord')">
              <div>{{ $t('lang.betActivity.history') + ' >' }}</div>
            </div>
          </div>
        </div>
        <div class="getGiftBox-row">
          <div class="getGiftBox-center">
            <div class="amount">
              <p>{{ $t('lang.account.currencyType') }}{{ allAmountShow }}</p>
            </div>
            <div class="text">
              <p>{{ $t('lang.VIP.cashReceived') }}:{{ $t('lang.account.currencyType') }}{{
                  userVipInfo.ClaimedReward
                }}</p>
            </div>
          </div>
        </div>
        <div class="getGiftBox-row">
          <div class="getGiftBox-item">
            <div class="yellow" @click="receiveNow">{{ $t('lang.VIP.getItNow') }}</div>
          </div>
        </div>
      </div>
      <div class="bannerBox">
        <div class="banner-bottom">
          <Swipe
            :auto="5000"
            v-if="bannerList.length > 0"
          >
            <SwipeItem
              v-for="(item, i) in bannerList"
              :key="'p' + i"
              v-if="checkBannerCondition(item.condition)"
            >
              <div class="carousel-item">
                <img
                  :alt="item.Name"
                  :src="item.ImageSrc"
                  class="banner-image"
                  @click="bannerAction(item.Type, item.RedirectPath, item.RedirectParams, item.IframeControlProperty, item.ModalControlProperty)"
                >
              </div>
            </SwipeItem>
          </Swipe>
        </div>
      </div>
      <div class="gameBox">
        <div class="game-top">
          <div class="title"><span style="font-weight: 700;font-size: 5.277vw">▋{{ $t('lang.VIP.hot') }}</span></div>
          <div class="seeAll"></div>
        </div>
        <div class="game-bottom">
          <div class="game"
               v-for="(item, index) in gameList"
               :key="'recommend'+index"
          >
            <div class="imgContainer">
              <div class="game-image-wrapper" :style="{backgroundImage:'url('+item.ThumbnailUrl+')'}"
                   @click="fetchGame(item)">
              </div>
            </div>
            <p>{{ item.GameNameEn }}</p>
          </div>
        </div>
      </div>
    </div>
    <IFrame3Part
      :iFrameSrc="iFrameSrc"
      :handelClose="() => handleCloseIFrame3Part('showJiliSlotsTournament')"
      v-if="showJiliSlotsTournament"
    >
    </IFrame3Part>
    <div class="alarBg" v-if="alarmShow">
      <div class="closeAlarmArea" @click="closeAlarm"/>
      <div class="alarmContent">
        <p v-for="(msg,index) in  $t('lang.vipAlarm.msg')" :key="index">{{ msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import Swiper from 'swiper'
import progressLine from '@/components/ProgressLine/index'
import TopBack from '@/components/TopBack/index'
import star from '@/assets/images/vip/star.svg'
import enjoy1 from '@/assets/images/vip/enjoy1.png'
import enjoy2 from '@/assets/images/vip/enjoy2.png'
import enjoy3 from '@/assets/images/vip/enjoy3.png'
import enjoy4 from '@/assets/images/vip/enjoy4.png'
import left from '@/assets/images/vip/left.svg'
import alarm from '@/assets/images/vip/alarm.svg'
import IFrame3Part from '@/components/IFrame3Part/index'
import {Swipe, SwipeItem, Toast} from 'mint-ui'
import {checkBannerCondition, fetchBalance, LogUtils} from '@/utils'
import config from '../../../static/config/config'
import store from '@/store/store'

export default {
  name: 'vip',
  computed: {},
  data () {
    return {
      alarm,
      alarmShow: false,
      alarmRedShow: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      allAmountShow: 0,
      currentLevel: 9,
      levelIndex: 0,
      fetchBalance,
      checkBannerCondition,
      showJiliSlotsTournament: false,
      iFrameSrc: 'https://history.jlfafafa3.com/action/20230726K/slot',
      levelSwiper: {},
      gameList: [],
      bannerList: [],
      vipConfigList: [
        {
          level: 0,
          color1: '#000000',
          color2: '#333333',
          color3: '#242424',
          color4: '#313131',
          color5: '#5D5D5D',
          color6: '#969696'
        },
        {
          level: 1,
          color1: '#0D0D0D',
          color2: '#5B5B5B',
          color3: '#0D0D0D',
          color4: '#313131',
          color5: '#5D5D5D',
          color6: '#3D3D3D'
        },
        {
          level: 2,
          color1: '#6B3F18',
          color2: '#835F40',
          color3: '#6D421C',
          color4: '#582C0E',
          color5: '#81573D',
          color6: '#886445'
        },
        {
          level: 3,
          color1: '#3F3F3F',
          color2: '#575757',
          color3: '#404040',
          color4: '#DEDEDE',
          color5: '#5F5F5F',
          color6: '#494949'
        },
        {
          level: 4,
          color1: '#4C2E0D',
          color2: '#4C2E0D',
          color3: '#4C2E0D',
          color4: '#4A2B06',
          color5: '#714F23',
          color6: '#82623E'
        },
        {
          level: 5,
          color1: '#23443E',
          color2: '#2E3E3B',
          color3: '#0E2C27',
          color4: '#0A7166',
          color5: '#0D423D',
          color6: '#163D3A'
        },
        {
          level: 6,
          color1: '#0B2D0A',
          color2: '#265624',
          color3: '#0B2D0A',
          color4: '#1D711B',
          color5: '#0A3109',
          color6: '#1D4621'
        },
        {
          level: 7,
          color1: '#181D52',
          color2: '#2E3368',
          color3: '#1A1F54',
          color4: '#DEDEDE',
          color5: '#15205A',
          color6: '#35386F'
        },
        {
          level: 8,
          color1: '#EDEDEE',
          color2: '#CDCFD2',
          color3: '#D8D8D8',
          color4: '#DEDEDE',
          color5: '#909090',
          color6: '#D4D4D4'
        },
        {
          level: 9,
          color1: '#CFCFCF',
          color2: '#676767',
          color3: '#959595',
          color4: '#ECECEC',
          color5: '#414141',
          color6: '#8E8E8E'
        },
        {
          level: 10,
          color1: '#CFCFCF',
          color2: '#676767',
          color3: '#F2F2F2',
          color4: '#ECECEC',
          color5: '#313131',
          color6: '#8E8E8E'
        },
        {
          level: 11,
          color1: '#CFCFCF',
          color2: '#676767',
          color3: '#F2F2F2',
          color4: '#ECECEC',
          color5: '#313131',
          color6: '#8E8E8E'
        }
      ],
      vipSettingInfo: [
        {
          'VipLevel': 0,
          'IsUpVipLevel': false,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '0%',
          'SportsGames': '0%',
          'FishingGames': '0%',
          'SlotGames': '0%',
          'LiveCasino': '0%',
          'Crash': '0%',
          'Promotion': false,
          'WithdrawCount': 0,
          'CustomerManager': false,
          'FestivalGift': false,
          'BirthdayGift': false
        },
        {
          'VipLevel': 1,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': false,
          'WithdrawCount': 0,
          'CustomerManager': false,
          'FestivalGift': false,
          'BirthdayGift': false
        },
        {
          'VipLevel': 2,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': false,
          'WithdrawCount': 0,
          'CustomerManager': false,
          'FestivalGift': false,
          'BirthdayGift': false
        },
        {
          'VipLevel': 3,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': false,
          'WithdrawCount': 0,
          'CustomerManager': false,
          'FestivalGift': false,
          'BirthdayGift': true
        },
        {
          'VipLevel': 4,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': false,
          'BirthdayGift': true
        },
        {
          'VipLevel': 5,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': false,
          'BirthdayGift': true
        },
        {
          'VipLevel': 6,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': true,
          'BirthdayGift': true
        },
        {
          'VipLevel': 7,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': true,
          'BirthdayGift': true
        },
        {
          'VipLevel': 8,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': true,
          'BirthdayGift': true
        },
        {
          'VipLevel': 9,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': true,
          'BirthdayGift': true
        },
        {
          'VipLevel': 10,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': true,
          'BirthdayGift': true
        },
        {
          'VipLevel': 11,
          'IsUpVipLevel': true,
          'TargetValue': 0,
          'ReachedValue': 0,
          'UpVipReward': 0,
          'WeekReward': 0,
          'Card': '',
          'SportsGames': '',
          'FishingGames': '',
          'SlotGames': '',
          'LiveCasino': '',
          'Crash': '',
          'Promotion': true,
          'WithdrawCount': 0,
          'CustomerManager': true,
          'FestivalGift': true,
          'BirthdayGift': true
        }
      ],
      vipActivitySetting: {},
      userVipInfo: {
        VipBetReward: 0,
        VipLevelReward: 0,
        VipWeekReward: 0,
        ClaimedReward: 0,
        ServiceTel: '',
        FirstLevelFive: false,
        FirstLevelSix: false,
        FirstLevelFiveHint: false,
        FirstLevelSixHint: false,
        Birthday: null,
        GradingHint: false,
        GradingAmount: 0,
        GradingDays: 0
      },
      star,
      left,
      enjoy1,
      enjoy2,
      enjoy3,
      enjoy4,
      enjoyImg: [
        {img: enjoy1, text: this.$t('lang.VIP.levelGift')},
        {img: enjoy2, text: this.$t('lang.VIP.cardRebates')},
        {img: enjoy3, text: this.$t('lang.VIP.Offers')},
        {img: enjoy4, text: this.$t('lang.VIP.manager')}
      ]
    }
  },
  watch: {
    '$store.state.showGame': function (n) {
      store.commit('setUserOnGame', n)
      if (n === false) {
        this.fetchData()
      }
    },
    '$store.state.locale': function () {
      this.enjoyImg = [
        {img: enjoy1, text: this.$t('lang.VIP.levelGift')},
        {img: enjoy2, text: this.$t('lang.VIP.cardRebates')},
        {img: enjoy3, text: this.$t('lang.VIP.Offers')},
        {img: enjoy4, text: this.$t('lang.VIP.manager')}
      ]
    }
  },
  components: {
    Swipe,
    SwipeItem,
    IFrame3Part,
    TopBack,
    progressLine
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    getAlarmMsg () {
      this.readAlarm()
      this.alarmShow = true
    },
    closeAlarm () {
      this.alarmShow = false
    },
    readAlarm () {
      if (this.userInfo && this.alarmRedShow === true) {
        this.alarmRedShow = false
        localStorage.setItem('vipAlarm' + this.userInfo.UserId, '1')
      }
    },
    getRedShow () {
      if (!this.userInfo) {
        this.alarmRedShow = false
        return
      }
      const vipAlarm = localStorage.getItem('vipAlarm' + this.userInfo.UserId)
      this.alarmRedShow = !(vipAlarm && vipAlarm === '1')
    },
    getDateEnd () {
      const currentDate = new Date()
      const targetDate = new Date('2025-01-01 00:00:00')
      return currentDate < targetDate
    },
    fetchData () {
      if (!this.userInfo || !this.userInfo.UserId) {
        this.$router.push('/Login')
        return
      }
      let that = this
      request('post', 'innovation/vip/get_user_vip', {UserId: this.userInfo.UserId}, true).then(res => {
        this.getRedShow()
        if (res && res.userVipInfo && res.userVipInfo.Birthday) {
          sessionStorage.Birthday = res.userVipInfo.Birthday
        } else {
          sessionStorage.removeItem('Birthday')
        }
        that.vipSettingInfo = res.vipSettingInfo
        that.userVipInfo = res.userVipInfo
        that.currentLevel = res.userVipInfo.VipLevel
        that.levelIndex = this.currentLevel
        that.gameList = res.VipGames
        that.bannerList = res.VipBanners
        that.levelSwiper = new Swiper('.swiper-container', {
          direction: 'horizontal', // 滑动方向，可设置水平(horizontal)或垂直(vertical)。
          loop: false, // 设置为true 则开启loop模式
          autoplay: 3000, // 自动切换时间
          slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量(carousel模式)。类型：number or auto
          centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
          spaceBetween: 0, // 在slide之间设置距离（单位px）。
          initialSlide: that.levelIndex,
          loopAdditionaSlider: 2, // loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。
          on: {
            slideChangeTransitionStart: function (e) {
              that.levelIndex = e.activeIndex
            }
          }
        })
        that.levelIndex = that.levelSwiper.activeIndex
        that.allAmountShow = that.userVipInfo.VipBetReward + that.userVipInfo.VipLevelReward + that.userVipInfo.VipWeekReward
        // 首次达到指定等级直接跳转到指定页面
        if (res.userVipInfo.FirstLevelFiveHint) {
          that.enjoyDetail(7)
          that.cancelRemind(',vip_level_5,')
        } else if (res.userVipInfo.FirstLevelSixHint) {
          that.enjoyDetail(10)
          that.cancelRemind(',vip_level_6,')
        }
        if (res.userVipInfo.GradingHint && res.userVipInfo.GradingAmount > 0) {
          let msg = that.$t('lang.VIP.toastMsg').replace('{amount}', res.userVipInfo.GradingAmount)
          msg = msg.replace('{day}', res.userVipInfo.GradingDays)
          that.cancelRemind(',grading_hint,')
          Toast({message: msg, duration: 5000})
        }
        this.$store.commit('setVipHint', res.userVipInfo.VipLevelReward > 0 || res.userVipInfo.VipWeekReward > 0)
      })
    },
    calcAmountNotReached (index) {
      if (index === 0) {
        return ''
      }
      let total = this.vipSettingInfo[index].TargetValue
      let current = this.vipSettingInfo[index].ReachedValue
      if (index > this.currentLevel) {
        return this.$t('lang.VIP.rebets') + (total - current) + this.$t('lang.VIP.reachedLevel')
      } else if (total > current) {
        return this.$t('lang.VIP.rebets') + (total - current) + this.$t('lang.VIP.toRelegate')
      } else {
        return this.$t('lang.VIP.relegated')
      }
    },
    enjoyDetail (index) {
      let data = this.vipSettingInfo[this.currentLevel]
      data.currentIndex = index
      data.Level2Reward = this.userVipInfo.VipLevelReward
      data.Week2Reward = this.userVipInfo.VipWeekReward
      data.phoneNum = this.userVipInfo.ServiceTel
      localStorage.setItem('vipInfo', JSON.stringify(data))
      localStorage.setItem('vipSetting', JSON.stringify(this.vipSettingInfo))
      this.$router.push('/VipBenefits')
    },
    bannerAction: function (type, path, param, iframeControlProperty, modalControlProperty) {
      switch (type) {
        case 'GoToTournament':
          if (!this.userInfo) {
            this.$router.push('/Login')
          } else {
            let data = {
              GameCategory: param.GameCategroy,
              Internation: this.$store.state.internation,
              ActivityCode: param.ActivityCode
            }
            request('post', 'innovation/activity/verifyifactivityon', data, false).then(res => {
              if (res === false) {
                // Toast(this.$t('lang.home.gameActivityOnThursday'))
                Toast(param.ActivityName + ' will start on Thursday 00:00:00 !')
              } else {
                this.$router.push({path: path})
                var activityItem = {
                  activityCode: param.ActivityCode,
                  category: param.GameCategroy,
                  activityImage: param.ActivityImage,
                  activityName: param.ActivityName,
                  bannerImage: param.BannerImage
                }
                sessionStorage.setItem('selectedActivity', JSON.stringify(activityItem))
                sessionStorage.setItem('SelectedActivityBanner', param.BannerImage)
                sessionStorage.setItem('comeFromTournament', '0') // 去往游戏类活动页时 selectedActivity
                this.selectActivity()
              }
            })
          }
          break
        case 'GoToRoute':
          if (path) {
            this.$router.push({path: path, query: {param: param}})
          }
          break
        case 'PlayGame':
          this.fetchGame(JSON.parse(param))
          break
        case 'ShowIframe':
          if (this.userInfo) {
            this[iframeControlProperty] = true // Banner中需要跳转到第三方页面的, 以iFrame形式显示
          } else {
            this.$router.push('/Login')
          }
          break
        case 'ShowModal':
          if (modalControlProperty && modalControlProperty === 'showLuckyWheelGamePop') {
            if (!this.wheelList || this.wheelList.length === 0) {
              let data = {}
              if (this.userInfo) {
                data = {UserId: this.userInfo.UserId}
              }
              request('post', '/innovation/luckywheel/get_wheel', data, false).then(res => {
                this.wheelList = res
                this.onShowLuckyWheelGamePop(this.wheelList[0])
              })
            } else {
              this.onShowLuckyWheelGamePop(this.wheelList[0])
            }
          } else {
            this[modalControlProperty] = true // 显示自研游戏（以组件弹出式对话框的形式）
          }
          break
      }
    },
    fetchGame (game) { // 原来的fetchGame
      if (this.userInfo) {
        if (this.$store.state.banUserId.includes(this.userInfo.UserId)) {
          Toast(this.$t('lang.home.gameMaintenancePrompt'))
          return
        }
        const url = '/innovation/game/getgameurl'
        const data = {
          userId: this.userInfo.UserId || '',
          gameCode: game.GameCode,
          gameProviderId: game.GameProviderId,
          deviceWidth: document.body.clientWidth,
          lang: localStorage.getItem('locale'),
          internation: this.$store.state.internation,
          campaignId: localStorage.getItem('cid'),
          localVersion: config.version,
          localApkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0'
        }
        request('post', url, data).then(res => {
          if (res.Url) {
            const gameInfo = {
              gameUrl: res.Url,
              gameImg: game.ThumbnailUrl,
              gameName: game.GameNameEn
            }
            this.$store.commit('setShowGame', true)
            this.$store.commit('setGameInfo', gameInfo)
          } else {
            Toast(this.$t('lang.home.gameMaintenancePrompt'))
          }
        }).catch(() => {
          Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
        })
      } else {
        this.$router.push('/Login')
      }
    },
    getVipLevelText (level) {
      return this.currentLevel === level ? this.$t('lang.VIP.currentLevel') : this.$t('lang.VIP.notActivated')
    },
    handleCloseIFrame3Part (iframeControlProperty) {
      this[iframeControlProperty] = false
    },
    confirmGotoPage () {
      this.$router.push('/Deposit')
    },
    gotoHome () {
      this.$router.push('/Home')
    },
    goto (path) {
      this.$router.push('/' + path)
    },
    receiveNow () {
      if (this.userVipInfo.VipLevelReward > 0 && this.userVipInfo.VipWeekReward > 0) {
        this.collectLevelAndWeekReward()
      } else if (this.userVipInfo.VipLevelReward > 0) {
        // this.enjoyDetail(0)
        this.collectLevelReward()
      } else if (this.userVipInfo.VipWeekReward > 0) {
        // this.enjoyDetail(8)
        this.collectWeekReward()
      } else if (this.userVipInfo.VipBetReward > 0) {
        this.goto('BetActivityRegularly')
      } else {
        Toast(this.$t('lang.VIP.noGifts'))
      }
    },
    collectLevelReward () {
      request('post', 'innovation/vip/collect_level_reward', {UserId: this.userInfo.UserId}, true).then(res => {
        if (res !== -1) {
          this.fetchBalance()
          this.fetchData()
          Toast(this.$t('lang.VIP.getOk'))
        }
      })
    },
    collectWeekReward () {
      request('post', 'innovation/vip/collect_week_reward', {UserId: this.userInfo.UserId}, true).then(res => {
        if (res !== -1) {
          LogUtils.logout9w()
          this.fetchBalance()
          this.fetchData()
          Toast(this.$t('lang.VIP.getOk'))
        }
      })
    },
    collectLevelAndWeekReward () {
      request('post', 'innovation/vip/collect_level_reward', {UserId: this.userInfo.UserId}, true).then(res => {
        if (res !== -1) {
          request('post', 'innovation/vip/collect_week_reward', {UserId: this.userInfo.UserId}, true).then(res => {
            if (res !== -1) {
              LogUtils.logout9w()
              this.fetchBalance()
              this.fetchData()
              Toast(this.$t('lang.VIP.getOk'))
            }
          })
        }
      })
    },
    // 消除提醒接口
    cancelRemind (cancelType) {
      request('post', 'innovation/vip/cancel_hint', {
        UserId: this.userInfo.UserId,
        cancelType: cancelType
      }, true).then(res => {
      })
    }
  }
}
</script>
<style lang="less" scoped>
.main-content {
  background-color: #121212;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 56px 0 70px 0; // 2022-03-27 CHP Fix tab被topbar遮挡
  overflow-x: hidden;

  .top {
    position: relative;
    display: flex;
    background-color: #121212;
    width: 100vw;

    .title {
      margin-top: 8px;
      margin-left: 4.5vw;
      width: calc(100vw - 180px);
      text-align: center;
      font-size: 5vw;
      line-height: 8.333vw;
      background-image: linear-gradient(99.1deg, #F9DCA7 5.72%, #EBDDC4 35.98%, #DAB470 102.55%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-weight: 700;
    }

    .alarm {
      position: absolute;
      right: 7.8vw;
      width: 5.25vw;
      height: 10.555vw;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99;

      img {
        width: 5.25vw;
        height: 5.833vw;
      }
    }

    .red-alarm-dot {
      position: absolute;
      top: 1.8vw;
      right: 6.2vw;
      width: 1.6667vw;
      height: 1.6667vw;
      background: #ff0000;
      border-radius: 50%;
    }
  }

  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
  }

  .swiperBox {
    position: relative;
    top: 0.5vh;
    height: max-content;

    .swiper-background {
      width: 100vw;
      height: 43.28vw;
      background-repeat: no-repeat;
      background-size: cover;
      margin-top: -8vh;
    }

    .swiper-container {
      margin-top: -8vh;
      width: 100vw;
      height: max-content;
    }

    .swiper-slide {
      width: 85vw;
      height: 33vw;
      overflow: hidden;
      display: flex;
      align-items: center;
      margin: calc(5vh + 6vw) 2vw 0 2vw;

      .img-box {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 10px;
        text-align: left;

        .img-box-title {
          margin-top: 2.21vh;
          display: flex;
          align-items: center;
          align-content: center;

          .vip-level {
            margin-left: 4.95vw;
            font-size: 6.95vw;
            font-weight: 700;
          }

          .current-level {
            border-radius: 10px;
            margin-left: 2vw;
            font-size: 2.66vw;
            font-weight: 400;
            width: max-content;
            height: max-content;

            div {
              margin: 2px 2vw;
            }
          }
        }

        .middle-box {
          position: relative;
          width: 100%;
          height: 12.22vw;
          padding-left: 4.95vw;
          font-size: 3.27vw;
          font-weight: 700;

          div:first-of-type {
            position: absolute;
            top: 0;
          }

          div:last-of-type {
            position: absolute;
            bottom: 0;
            width: 88%;
            line-height: 2.5vw;
          }
        }
      }
    }

    .swiper-slide-active {
      width: 85vw;
      height: 39vw;
      margin: 5vh 2vw 0 2vw;

      .img-box {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border-radius: 5px;
        text-align: left;

        .middle-box {
          position: relative;
          width: 100%;
          height: 15.22vw;
          padding-left: 4.95vw;
          font-size: 3.27vw;
          font-weight: 700;

          div {
            position: absolute;
            bottom: 0;
          }
        }
      }
    }

    .bottom-line {
      display: flex;
      margin-left: 4.95vw;

      .color3 {
        letter-spacing: -0.02em;
        font-size: 4.1vw;
        font-weight: 700;
        line-height: 25px;
        margin-left: 10px;
      }

      .color3_shadow {
        letter-spacing: -0.02em;
        font-size: calc(4.1vw - 1px);
        font-weight: 700;
        line-height: 25px;
        margin-left: 10px;
        text-shadow: -1px -1px 0 #000,
          1px -1px 0 #000,
        -1px 1px 0 #000,
        1px 1px 0 #000;
      }
    }
  }

  .last-boxes-container {
    width: 100%;
    background-color: #E4E4E4;
    color: #121212;

    .enjoymentBox {
      width: 100vw;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-top: -1px;
      padding-top: 2vh;
      height: 23vh;

      .enjoyment-top {
        margin: 0 auto 1.75vh auto;
        padding-top: 1.25vh;
        border-top: 3px solid #121212;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        min-height: max-content;

        .title {
          color: #D9D9D9;
          width: 68vw;
          text-align: left;
          padding-left: 15px;
          font-size: 4.87vw;
          font-weight: 700;
          line-height: calc(4.87vw + 3px);
        }

        .seeAll {
          display: flex;
          justify-content: flex-end;
          color: #C9C9C9;
          width: 32vw;
          text-align: right;
          padding-right: 15px;
          font-size: 3.59vw;
          font-weight: 400;
          line-height: calc(3.59vw + 6px);

          img {
            width: 3.59vw;
            margin-left: 5px;
          }
        }
      }

      .enjoyment-bottom {
        min-height: max-content;

        .bottom-row {
          width: 100%;
          display: flex;
          justify-content: center;
          padding: 0 1vw 1vh 2vw;

          .row-item {
            display: block;

            .imgHull {
              position: relative;
              left: 50%;
              transform: translate(-50%);
              width: 12.5vw;
              height: 12.5vw;
              overflow: visible;

              .red-dot {
                position: absolute;
                top: 0.3vw;
                right: 0vw;
                width: 2.3vw;
                height: 2.3vw;
                background-color: #D01313;
                border-radius: 50%; /* 将方块变成圆形 */
                display: inline-block; /* 使其在行内显示 */
              }
            }

            img {
              width: 100%;
            }

            div {
              text-align: center;
            }

            .enjoy-text {
              color: #B7B7B7;
              font-size: 3.408vw;
              font-weight: 400;
              line-height: calc(3.408vw + 1px);
              letter-spacing: -0.06em;
            }

            .enjoy-amount {
              color: #5B5B5B;
              font-size: 3.165vw;
              font-weight: 400;
              line-height: calc(3.165vw + 5px);
            }
          }
        }
      }
    }

    .getGiftBox {
      margin: -2vh auto 0 auto;
      border-radius: 17px;
      border-image: linear-gradient(to right, #B6B6B6 18.42%, #393939 40.47%, #747474 114.62%) 1;
      width: 95vw;
      background: linear-gradient(0deg, #1E1A1A, #1E1A1A),
      linear-gradient(123.49deg, #B6B6B6 18.42%, #393939 40.47%, #747474 114.62%);

      .getGiftBox-row:last-of-type {
        margin: 0 auto 0.8vh auto;
      }

      .getGiftBox-row {
        display: flex;
        margin: 0 auto 2vh auto;
        width: 100%;
        height: 17.4vw;

        .getGiftBox-top {
          position: relative;
          margin-left: 5.8vw;
          width: 100%;
          display: flex;
          align-items: center;

          .black {
            position: absolute;
            right: 4vw;
            text-align: right;
            color: #6B6B6B;
            font-size: 4.703vw;
            font-weight: 400;
          }

          img {
            width: 5.833vw;
          }

          p {
            background: linear-gradient(to right, #E8CB8B, #FFF1D2);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-left: 1.388vw;
            font-size: 6.111vw;
            font-weight: 700;
            line-height: 6.944vw;
            text-align: left;
            transform: skew(-10deg);
          }
        }

        .getGiftBox-item {
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: center;

          .yellow {
            background: linear-gradient(90.83deg, #E3C891 -1.31%, #F8E1B5 108.48%);
            color: #000000;
            text-align: center;
            line-height: 11.44vw;
            width: 56.441vw;
            height: 11.44vw;
            border-radius: 3px;
            font-size: 5.111vw;
            font-weight: 700;
          }
        }

        .getGiftBox-center {
          display: flex;
          flex-wrap: wrap;

          .amount {
            font-size: 11.388vw;
            font-weight: 700;
            line-height: 13.055vw;
            color: #FFFFFF;
          }

          .text {
            font-size: 6.111vw;
            font-weight: 700;
            line-height: 6.111vw;
            color: #4A4A4A;
          }

          div {
            width: 95vw;
            text-align: center;
          }
        }
      }
    }

    .bannerBox {
      margin: 3vh auto 0 auto;
      width: 95vw;

      .banner-bottom {
        height: 45.5vw;

        .banner-image {
          width: 100%;
          height: 36.58vw;
          border: 4px solid #0A0A0A;
          background: #0A0A0A;
        }
      }
    }

    .gameBox {
      margin: 1vh auto 0 auto;
      width: 100vw;
      border-radius: 20px 20px 0 0;
      background-color: #FFFFFF;

      .game-top {
        margin: 2vh auto 0.5vh auto;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        min-height: max-content;

        .title {
          margin-top: 1.5vh;
          color: #000000;
          width: 70vw;
          text-align: left;
          padding-left: 4.166vw;
          font-size: 6.111vw;
          font-weight: 700;
          line-height: 8.611vw;
        }
      }

      .game-bottom {
        height: max-content;
        padding-top: 1vh;
        overflow: auto;

        .game {
          width: 45%;
          margin: 0 1% 20px 3%;
          float: left;

          .imgContainer {
            position: relative;
            height: 0;
            padding-bottom: 60%;
            overflow: hidden;
            border-radius: 6px;

            .game-image-wrapper {
              background-position: center;
              width: 100%;
              height: 26.4vw;
              background-repeat: no-repeat;
              background-size: cover;
              position: relative;
            }
          }

          p {
            text-align: center;
            width: 100%;
            color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 5vw;
            font-weight: 700;
            line-height: 6.944vw;
          }
        }

        .last {
          margin-right: 0;
        }

        .showMore {
          text-align: center;

          img {
            width: 2.777vw;
          }
        }

        /deep/ .mint-loadmore-content {
          position: relative;

          &:after {
            content: "020";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }

          .mint-loadmore-bottom {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 20px;
            line-height: 20px;
            margin-bottom: -20px;
          }
        }
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

.alarBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.65);
  z-index: 9999;

  .closeAlarmArea {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }

  .alarmContent {
    position: absolute;
    width: 86.6667vw;
    height: max-content;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border-radius: 4.166vw;
    border: 0.3vw solid #737373;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
    padding: 11.38vw 4.72vw;

    p {
      font-family: Inter;
      font-size: 3.75vw;
      font-weight: 500;
      line-height: 5vw;
      text-align: center;
      color: #DDDDDD;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Vip/index.vue